import { render } from "./HiCodeViewer.vue?vue&type=template&id=5fbf5d7e&scoped=true"
import script from "./HiCodeViewer.vue?vue&type=script&lang=js"
export * from "./HiCodeViewer.vue?vue&type=script&lang=js"

import "./HiCodeViewer.vue?vue&type=style&index=0&id=5fbf5d7e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbf5d7e"]])

export default __exports__